<template>
  <div class="search-results">
    <perfect-scrollbar :options="{suppressScrollX: true}">

      <!-- 🔹 Секція ЗОЗ -->
      <div v-if="section === 'zoz'">
        <div class="card-wrapper" v-for="points2 in points" :key="points2.uid">
          <CollapsibleDiv
            :title="points2.title"
            :open.sync="points2.selected"
            @change="toggle(points2)"
            ref="cards"
          >

            <!-- Використовуємо InfoCard для ЗОЗ -->
            <div v-if="Array.isArray(points2.full_data?.data) && points2.full_data.data.length > 0">
              <InfoCard :d="p" v-for="p in points2.full_data.data" :key="p.uid" ref="elements" @hook:mounted="logData(p)"/>
            </div>

            <!-- Якщо немає data, використовуємо full_data -->
            <div v-else-if="points2.full_data">
              <InfoCard :d="points2.full_data" ref="elements" @hook:mounted="logData(points2.full_data)"/>
            </div>
            <p v-else>Немає доступних даних для відображення</p>

          </CollapsibleDiv>
        </div>
      </div>

      <!-- 🔹 Секція ПЗШ -->
      <div v-if="section === 'harm_reduction'">
        <p>
          Знайдено організацій: {{ points?.length || 0 }}
          (Всього місць надання послуг: {{ addressCount }})
        </p>
        <div class="card-wrapper" v-for="(group, index) in points" :key="index">
          <CollapsibleDiv
            :title="group.title"
            :open.sync="group.selected"
            @change="toggle(group)"
            ref="cards"
          >

            <!-- Відображаємо всі адреси в одній групі -->
            <div v-if="Array.isArray(group.data)">
              <InfoCardSoc
                v-for="(addr, addrIndex) in getValidAddresses(group)"
                :key="addrIndex"
                :d="addr"
                ref="elements"
              />
              <p v-if="group.data.length === 0">Немає доступних даних для відображення</p>
            </div>
            <p v-else>Немає доступних даних для відображення</p>

          </CollapsibleDiv>
        </div>
      </div>

    </perfect-scrollbar>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'
import InfoCard from './InfoCard.vue';
import InfoCardSoc from './InfoCardSoc.vue';
//import FilterResults from "./FilterResults";
import CollapsibleDiv from "./CollapsibleDiv.vue";

export default {
  props: ["points", "section"],
  components: {
    PerfectScrollbar,
    CollapsibleDiv,
    InfoCard,
    InfoCardSoc,
//    FilterResults
  },

  computed: {
    addressCount() {
      return Array.isArray(this.points)
        ? this.points.reduce((acc, g) => acc + (Array.isArray(g?.data) ? g.data.length : 0), 0)
        : 0;
    }
  },

  mounted() {
  },

  methods: {
    logData() {},
    toggle(p) {
      if (!p) {
        return;
      }

      if (typeof p.selected === "undefined") {
        this.$set(p, "selected", false);
      }

      this.$set(p, "selected", !p.selected);
      this.$forceUpdate();
    },

    scrollIntoView(p) {
      let outerIndex2 = this.$refs.cards.findIndex(outer => outer.$children.some(inner => inner.$attrs.id === p.uid));
      if (outerIndex2 !== -1) {
        setTimeout(() => this.$refs.cards[outerIndex2].toggle(true), 0);

        const innerIndex2 = this.$refs.cards[outerIndex2].$children.findIndex(inner => inner.$attrs.id === p.uid);
        if (innerIndex2 !== -1) {
          setTimeout(() => this.$refs.cards[outerIndex2].$children[innerIndex2].$el.scrollIntoView({
            block: 'start'
          }), 0);
        }
      }
    },

    getValidAddresses(group) {
      if (!Array.isArray(group?.data)) return [];
      return group.data.filter(addr => addr && typeof addr === 'object');
    },
  },

  watch: {}

}
</script>

<style lang="scss" scoped>
.search-results {
  width: 100%;

  .supertitle {
    font-size: 1.3rem;
  }

  .info-card {
    margin-bottom: 1rem;
  }
}
</style>

<style lang="scss">

// .supertitle {
//     font-size: 1.3rem;
// }

.ps {
  height: 500px;

  .ps__rail-y {
    opacity: 0.6 !important;
    background-color: #eee !important;
  }
}
</style>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
